<template>
    <ModalTheme :with-content="true" @close="closeModal" :theme="true" :fix-height="false">
        <template slot="main">
            <loader :loading="true" v-if="loading"></loader>
            <h1 class="text-center">{{ typeUpload === "pdf" ? $t("help.newPdf") : $t("help.newVideo") }}</h1>
            <div class="content-form">
                <div class="form-group">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{ $t("template.form.name") }}*</label>
                        <div class="col-sm-10">
                            <input :max-length="100" type="text" :required="true" v-model="help.name" class="form-control" id="staticEmail" />
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="typeUpload === 'video'">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{ $t("template.form.link") }}*</label>
                        <div class="col-sm-10"><input :max-length="255" type="text" :required="true" v-model="help.link" class="form-control" /></div>
                    </div>
                </div>
                <div class="form-group" v-else-if="typeUpload === 'pdf'">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{ $t("template.form.link") }}*</label>
                        <div class="col-sm-10">
                            <input
                                :max-length="255"
                                type="file"
                                :required="true"
                                v-on:change="handleFileUpload"
                                class="form-control"
                                accept="application/pdf"
                                id="file"
                                ref="file"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label class="col-sm-2 col-form-label">{{ $t("template.form.category") }}*</label>
                    <div class="col-sm-10">
                        <div class="d-flex justify-content-start flex-wrap apps">
                            <button
                                :class="help.applicationId === app.id ? 'btn btn-primary' : 'btn btn-dark'"
                                @click="changeApp(app)"
                                v-bind:key="key"
                                v-for="(app, key) in applications"
                            >
                                {{ app.title }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center actions">
                    <button @click="closeModal" class="btn btn-dark">{{ $t("common.cancel") }}</button>
                    <button @click="upload" class="btn btn-dark">{{ $t("common.save") }}</button>
                </div>
            </div>
        </template>
    </ModalTheme>
</template>
<script>
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import ModalTheme from "@/components/ui/ModalTheme";
import loader from "@/components/loader/loader";
import TryLoad from "@/mixins/TryLoadMixin";
import helpService from "@/services/help";
export default {
    components: { ModalTheme, loader, TextInputBloc },
    props: {
        typeUpload: {
            type: String,
            required: true
        },
        selectedApplicationId: {
            type: Number,
            required: false
        },
        applications: {
            type: Array,
            required: true
        },
        selectedFile: {
            type: Object,
            required: false
        }
    },
    mixins: [TryLoad],
    created() {
        if (this.selectedFile != null) {
            this.help.name = this.selectedFile.name;
            this.help.id = this.selectedFile.id;
            this.help.link = this.selectedFile.link;
            this.help.applicationId = this.selectedApplicationId;
        }
    },
    data() {
        return {
            help: {
                id: null,
                name: "",
                type: this.typeUpload,
                file: null,
                link: "",
                applicationId: null
            },
            loading: false
        };
    },
    methods: {
        closeModal() {
            this.help = null;
            this.$emit("closed");
        },
        handleFileUpload() {
            this.help.file = this.$refs.file.files[0];
        },
        changeApp(app) {
            this.help.applicationId = app.id;
        },
        async upload() {
            if (this.help.id != null || (this.help.id == null && this.help.file != null) || (this.help.link != null && this.help.name != null)) {
                this.loading = true;
                if (this.typeUpload === "pdf") {
                    await helpService
                        .uploadPdf(this.help.file, this.help.applicationId, this.help.name, this.help.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit("uploadSuccess", this.help.applicationId);
                        })
                        .catch(e => {
                            this.loading = false;
                            this.dialogError(this.$t("help.uploadPdfError"));
                        });
                } else if (this.typeUpload === "video") {
                    await helpService
                        .uploadLink(this.help.link, this.help.name, this.help.applicationId, this.help.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit("uploadSuccess", this.help.applicationId);
                        })
                        .catch(e => {
                            this.loading = false;
                            this.dialogError(this.$t("help.uploadPdfError"));
                        });
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.content-form {
    padding: 30px 0 10px;

    .apps {
        margin: 0 -3px;

        button {
            margin: 3px;
            border-radius: 0;
            &.btn-primary:hover {
                background-color: grey;
            }
            &:focus {
                outline: none;
                box-shadow: none;
            }
        }
    }

    label {
        color: black;
        font-weight: bold;
    }

    input {
        border-radius: 0;
        border: 1px solid;
        font-size: 16px;
        padding: 4px 12px;
        color: #a2a2a2;
        outline: none;
    }
    .actions {
        margin: 30px 0 0;

        .btn {
            border-radius: 0;
            margin: 7px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ModalHelpUpload.vue?73cab0c3